
export const customStyles = {
  overlay: {
    backgroundColor: 'rgb(0 0 0 / 60%)',
    zIndex: 999,
  },
  content: {
    padding: '0',
    border: 'none',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};
